import type { CityConfig } from "../city-template/types";

export const elmhurstConfig: CityConfig = {
  city: "Elmhurst",
  state: "Illinois",
  stateAbbr: "IL",
  slug: "elmhurst",
  route: "/cities/elmhurst",
  title: "Emergency Passport Elmhurst IL | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Elmhurst, Illinois — as fast as 24 hours. Fast passport renewal for Elmhurst University students, business travelers near O'Hare, and all DuPage County residents. A+ BBB rated registered State Dept. courier serving the western suburbs.",
  h1: "Emergency & Expedited Passport Services in Elmhurst, IL",
  heroSubtitle: "Elmhurst University student with a summer program in Florence and your passport just expired? Business traveler heading to London from O'Hare next week? DuPage County suburb just 15 minutes from O'Hare with no passport agency in town. We help Elmhurst residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier serving Elmhurst and the western suburbs.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Elmhurst%20Illinois%20charming%20downtown%20with%20the%20iconic%20York%20Theatre%20marquee%20and%20historic%20brick%20storefronts%20along%20York%20Road%2C%20Elmhurst%20University%20campus%20with%20Old%20Main%20building%20and%20manicured%20lawns%2C%20tree%20lined%20residential%20streets%20with%20well%20kept%20suburban%20homes%2C%20Wilder%20Park%20with%20the%20Elmhurst%20Art%20Museum%20and%20lush%20green%20spaces%20in%20the%20DuPage%20County%20suburbs%2C%20golden%20hour%20warm%20light%20over%20the%20western%20Chicago%20suburbs%2C%20professional%20soft%20focus%20landscape%20photography&width=1800&height=700&seq=elmhurst-hero-001&orientation=landscape",
  heroImageAlt: "Elmhurst Illinois downtown York Road and Elmhurst University campus at golden hour",
  geoPosition: "41.8995;-87.9403",
  geoPlacename: "Elmhurst, Illinois",
  lastModified: "2026-06-04",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 W Congress Pkwy, 4th Floor, Chicago, IL 60605",
    distance: "Approximately 30 minutes east of Elmhurst via I-290",
  },
  nearbyCitiesZips: [
    { name: "Elmhurst", zips: "60126" },
    { name: "Villa Park", zips: "60181" },
    { name: "Lombard", zips: "60148" },
    { name: "Addison", zips: "60101" },
    { name: "Bensenville", zips: "60106" },
    { name: "Berkeley", zips: "60163" },
    { name: "Oak Brook", zips: "60523" },
    { name: "Oakbrook Terrace", zips: "60181" },
    { name: "Northlake", zips: "60164" },
    { name: "Melrose Park", zips: "60160, 60164" },
    { name: "Franklin Park", zips: "60131" },
    { name: "Schiller Park", zips: "60176" },
    { name: "Itasca", zips: "60143" },
    { name: "Wood Dale", zips: "60191" },
    { name: "Hinsdale", zips: "60521" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Chicago Passport Agency — just 30 minutes away via I-290 but you skip the trip entirely" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting for Elmhurst and western suburban travelers" },
    { icon: "ri-graduation-cap-line", title: "Elmhurst University Hub", desc: "Serving Elmhurst University students and faculty with study abroad and international academic travel" },
    { icon: "ri-plane-line", title: "O'Hare Proximity", desc: "Just 15 minutes from O'Hare International — perfect for last-minute business and leisure travelers" },
  ],
  internalLinks: [
    { name: "Expedited passport in Schaumburg", route: "/cities/schaumburg" },
    { name: "Emergency passport help in Naperville", route: "/cities/naperville" },
    { name: "Urgent passport services in Oak Park", route: "/cities/oak-park" },
    { name: "Illinois passport services overview", route: "/states/illinois" },
  ],
  fpcOfficeAddress: "101 W Congress Pkwy, 4th Floor, Chicago, IL 60605",
  fpcOfficeNote: "Fast Passport Center serves Elmhurst, Illinois remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (just 30 minutes east via I-290) — without you making the trip. Elmhurst residents can ship from any UPS or FedEx in Elmhurst or nearby Villa Park. For western suburban travelers, our courier service saves navigating downtown Chicago and dealing with agency parking.",
  fpcOfficeDistance: "Serving Elmhurst, Villa Park, Lombard, Addison, Bensenville, Berkeley, Oak Brook, Oakbrook Terrace, Northlake, Melrose Park, Franklin Park, Schiller Park, Itasca, Wood Dale, Hinsdale, and the entire western DuPage County area",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Elmhurst and the entire western DuPage County region. From the historic downtown Elmhurst and York Road corridor to the Elmhurst University campus, from the residential neighborhoods to the commercial districts — we serve the entire Elmhurst community and surrounding suburbs.",
  nearbyCitiesIntro: "We serve Elmhurst and all nearby communities including Villa Park, Lombard, Addison, Bensenville, Berkeley, Oak Brook, Oakbrook Terrace, Northlake, Melrose Park, Franklin Park, Schiller Park, Itasca, Wood Dale, and Hinsdale.",
  howItWorksIntro: "Most Elmhurst travelers complete everything online and ship documents overnight. No need to drive downtown Chicago — our couriers handle the Chicago Passport Agency trip for you. For western suburban residents, this saves navigating the Eisenhower Expressway and downtown parking.",
  mistakesIntro: "Elmhurst is home to Elmhurst University with study abroad programs and is just 15 minutes from O'Hare International Airport — yet the nearest passport agency is still a downtown Chicago trip away. Here are the most common passport mistakes in the western suburbs.",
  testimonialsIntro: "Elmhurst travelers — from Elmhurst University students heading abroad and business travelers to O'Hare to DuPage County families and suburban professionals — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Elmhurst, IL? Here are the most common ones we hear from western suburban travelers.",
  statePageRoute: "/states/illinois",
  statePageName: "Illinois",
  dmvWebsite: "https://www.ilsos.gov/facilities/facilitylist.html",
  dmvLabel: "Illinois Secretary of State — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "1+ hour round trip to downtown Chicago", "Impractical for most suburban travelers"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "No downtown Chicago trip required", "Perfect for Elmhurst University study abroad deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Elmhurst travelers with immediate departure needs — as fast as 24 hours. Essential for Elmhurst University study abroad deadlines and O'Hare business travel.",
      bullets: ["24–48 hour turnaround available", "Chicago Passport Agency direct courier", "No downtown Chicago trip — ship locally"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Elmhurst adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Elmhurst address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Elmhurst residents — including Elmhurst University students, new citizens, and DuPage County families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Elmhurst residents who lost their passport before international travel, study abroad, or business trips.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Elmhurst and DuPage County area families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Elmhurst and DuPage County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized passport card for Elmhurst residents who need land/sea travel to Canada or Mexico — ideal for quick North American trips.",
      bullets: ["Land and sea travel to Canada, Mexico, Caribbean", "Wallet-sized convenience", "REAL ID compliant"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Passport replacement for Elmhurst residents with water-damaged, torn, or otherwise damaged passports that need urgent replacement.",
      bullets: ["DS-11 form with damage explanation", "Photo verification for identity matching", "Emergency replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Second valid passport book for Elmhurst business travelers and frequent international flyers who need a backup while one is with an embassy.",
      bullets: ["Second valid passport book", "Ideal for frequent business travelers", "Keep traveling while visa processes"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Elmhurst IL", description: "Urgent passport processing for Elmhurst Illinois travelers and Elmhurst University students with immediate departure needs." },
    { name: "Expedited Passport Renewal Elmhurst IL", description: "Fast passport renewal for Elmhurst Illinois residents and western suburban travelers." },
    { name: "First-Time Passport Elmhurst IL", description: "New passport application services for Elmhurst Illinois residents." },
    { name: "Child Passport Elmhurst IL", description: "Minor passport services for Elmhurst Illinois families with children under 16." },
  ],
  testimonials: [
    {
      name: "Sarah M.",
      location: "Elmhurst, IL — Elmhurst University",
      rating: 5,
      text: "Elmhurst University's summer program in Florence was confirmed and I realized my passport expired. Fast Passport Center renewed it in 3 days. Shipped from the UPS on York Road. Made it to Italy on time and had the most incredible summer. Every Elmhurst U student needs to know about this service.",
      service: "Passport Renewal",
    },
    {
      name: "David K.",
      location: "Elmhurst, IL",
      rating: 5,
      text: "Business trip to London from O'Hare — passport expired and I had 8 days. Fast Passport Center got me renewed in 4 days. Being 15 minutes from O'Hare is great but the downtown Chicago passport agency is still a hassle. The courier service is the smartest fast option for Elmhurst business travelers.",
      service: "Passport Renewal",
    },
    {
      name: "Jennifer T.",
      location: "Elmhurst, IL",
      rating: 5,
      text: "Family trip to Japan — my son's first passport and my daughter's renewal. Fast Passport Center walked us through both. Elmhurst post office on York was convenient. Both passports arrived in 5 days. DuPage County families, don't stress about passports — these folks handle everything.",
      service: "New & Child Passports",
    },
  ],
  facilities: [
    {
      id: "elm-1",
      name: "Elmhurst Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "154 W Park Ave",
      city: "Elmhurst",
      state: "IL",
      zip: "60126",
      phone: "(630) 833-1984",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Elmhurst, near York Road and downtown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Elmhurst acceptance facility. Convenient to downtown Elmhurst and the York Road corridor. Near Elmhurst University and Wilder Park. Appointments recommended — this is a popular suburban facility.",
      icon: "ri-mail-line",
    },
    {
      id: "elm-2",
      name: "Villa Park Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1415 S Ardmore Ave",
      city: "Villa Park",
      state: "IL",
      zip: "60181",
      phone: "(630) 832-1163",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Villa Park, approximately 2 miles west of Elmhurst",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for western Elmhurst residents near the Villa Park border. Good alternative with potentially shorter wait times than the Elmhurst facility. Near the Illinois Prairie Path.",
      icon: "ri-mail-line",
    },
    {
      id: "elm-3",
      name: "Lombard Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "380 E St Charles Rd",
      city: "Lombard",
      state: "IL",
      zip: "60148",
      phone: "(630) 629-0527",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Lombard, approximately 3 miles southwest of Elmhurst",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Lombard and southern Elmhurst residents. Near Yorktown Center and major shopping areas. Good alternative with extended weekday hours.",
      icon: "ri-mail-line",
    },
    {
      id: "elm-4",
      name: "Addison Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "175 S Lincoln Ave",
      city: "Addison",
      state: "IL",
      zip: "60101",
      phone: "(630) 543-2106",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Addison, approximately 4 miles northwest of Elmhurst",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Addison and northern Elmhurst residents. Near Addison Trail High School. Good alternative for northern DuPage County residents.",
      icon: "ri-mail-line",
    },
    {
      id: "elm-5",
      name: "Bensenville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "303 E Green St",
      city: "Bensenville",
      state: "IL",
      zip: "60106",
      phone: "(630) 766-0645",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Bensenville, approximately 4 miles north of Elmhurst",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Bensenville and northern Elmhurst area. Near O'Hare International Airport. Convenient for Elmhurst residents heading toward O'Hare for flights. Good alternative facility.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 30 min drive to Chicago", fpc: "No — ship from Elmhurst" },
    { feature: "Time Commitment", agency: "1+ hour round trip plus parking", fpc: "Minutes — ship from your neighborhood" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Practical for Suburbs", agency: "No — downtown parking is a hassle", fpc: "Yes — the smart fast solution" },
  ],
  mistakes: [
    {
      icon: "ri-calendar-close-line",
      title: "Elmhurst University Study Abroad Deadlines",
      description: "Elmhurst University students regularly discover expired or missing passports just weeks before summer programs, J-term, and semester abroad. The downtown Chicago agency is still a trip away. Our courier service is the fastest practical solution for Elmhurst U students.",
    },
    {
      icon: "ri-plane-line",
      title: "O'Hare Last-Minute Travel",
      description: "Being 15 minutes from O'Hare is amazing — but it also means Elmhurst residents book international trips on short notice. A missing or expired passport can ruin everything. Our 24–48 hour courier service means you can book that last-minute flight and still get your passport.",
    },
    {
      icon: "ri-passport-line",
      title: "Six-Month Validity Rule",
      description: "Many Elmhurst business travelers and vacationers don't know that numerous countries require 6 months of passport validity past the return date. A passport valid for 4 months is effectively expired for most European and Asian destinations popular from O'Hare.",
    },
    {
      icon: "ri-image-line",
      title: "Elmhurst University ID vs. Passport Photos",
      description: "Elmhurst University student IDs do not meet Department of State passport photo standards. The lighting, background, and sizing requirements are completely different. Always use a dedicated passport photo service.",
    },
    {
      icon: "ri-file-list-line",
      title: "Wrong Application Form",
      description: "Using DS-82 instead of DS-11 for first-time passports (or vice versa) is the #1 cause of rejection at Elmhurst and Villa Park acceptance facilities. Our document review catches this before submission — especially important for first-time student applicants.",
    },
    {
      icon: "ri-global-line",
      title: "Business Travel & Visa Confusion",
      description: "Elmhurst business travelers often confuse passport validity requirements with visa requirements. Your passport must be valid for the entire stay plus the 6-month buffer. For countries requiring visas (China, India, Russia, Brazil), start both processes early — neither can be rushed at the last minute.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Elmhurst or DuPage County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx on York Road or in downtown Elmhurst." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document — experienced with Elmhurst University study abroad, O'Hare business travel, and suburban family needs." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to the Chicago Passport Agency — just 30 minutes away but you never make the trip." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Elmhurst address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Elmhurst, IL?", a: "Fast Passport Center offers emergency passport processing in Elmhurst, Illinois in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (just 30 minutes east via I-290) — without you making the trip. For western suburban residents, this saves navigating downtown Chicago and dealing with federal building parking." },
    { q: "Does Elmhurst have a passport agency?", a: "No — Elmhurst does not have a regional passport agency. The nearest facility is the Chicago Passport Agency approximately 30 minutes east via I-290. Fast Passport Center's courier service is the most practical fast option for Elmhurst and western suburban residents — especially for Elmhurst University students who need their passports for study abroad." },
    { q: "Do you serve Elmhurst University students?", a: "Absolutely. Fast Passport Center serves Elmhurst University students, faculty, and staff. We understand summer programs, J-term deadlines, semester abroad, and international academic travel. Our 24–48 hour service is ideal for students who applied late or received last-minute acceptance to study abroad programs." },
    { q: "What airport do Elmhurst travelers use for international flights?", a: "Chicago O'Hare International Airport (ORD) is just 15 minutes north of Elmhurst via I-294 or York Road. It's one of the busiest international hubs in the country with direct flights to Europe, Asia, South America, and beyond. Chicago Midway (MDW) is also accessible in about 25 minutes for domestic connections." },
    { q: "Is being close to O'Hare a good reason to use your service?", a: "Ironically, yes. Being 15 minutes from O'Hare means Elmhurst residents often book international trips on short notice — and discover passport issues at the last minute. Our 24–48 hour courier service is the fastest practical solution when you booked that flight and realize your passport is expired the week before." },
    { q: "Can I get my child's passport expedited in Elmhurst?", a: "Yes. Fast Passport Center expedites child passports in Elmhurst for minors under 16. Both parents must appear or submit notarized consent. We guide DuPage County families through the entire DS-11 process for minors." },
    { q: "Where can I get passport photos in Elmhurst?", a: "Walgreens on York Road, the UPS Store in downtown Elmhurst, and CVS on North Avenue all offer passport photos. The Elmhurst Post Office on Park Avenue also provides photo services. Photos must be 2x2 inches on a white background." },
    { q: "Is there really no other fast option in the western suburbs?", a: "Honestly — no. The Chicago Passport Agency is 30 minutes away but requires appointments booked weeks in advance for non-emergencies. For urgent international travel from Elmhurst and the western suburbs, Fast Passport Center's courier service is the only practical 24–48 hour option. It's why Elmhurst University students, O'Hare business travelers, and DuPage County families rely on us." },
  ],
  photoLocations: [
    { name: "Walgreens — Elmhurst", address: "160 N York Rd, Elmhurst, IL 60126", hours: "Mon–Sun: 7AM–10PM" },
    { name: "UPS Store — Elmhurst", address: "110 W Park Ave, Elmhurst, IL 60126", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "CVS — Elmhurst", address: "110 W North Ave, Elmhurst, IL 60126", hours: "Mon–Sun: 8AM–9PM" },
    { name: "Elmhurst Post Office", address: "154 W Park Ave, Elmhurst, IL 60126", hours: "Mon–Fri: 9AM–4:30PM (photo services by appointment)" },
  ],
  dmvLocations: [
    { name: "Illinois SOS — Lombard", address: "837 S Westmore-Meyers Rd, Lombard, IL 60148", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Illinois Secretary of State for driver's licenses, REAL ID, and vehicle registration. Located in Lombard — closest full-service facility to Elmhurst. Online reservations strongly recommended.", featured: true },
    { name: "Illinois SOS — Melrose Park", address: "1903 N Mannheim Rd, Melrose Park, IL 60160", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Alternative SOS facility serving the Melrose Park and eastern Elmhurst area. REAL ID processing available. Generally fewer visitors than Lombard location.", featured: false },
  ],
  airports: [
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "Approximately 15 minutes north of Elmhurst via I-294",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Major international hub with extensive global connections. Most Elmhurst international travelers and Elmhurst University study abroad students use ORD for direct international flights. Just 15 minutes from downtown Elmhurst.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Flight Info",
      featured: true,
    },
    {
      code: "MDW",
      name: "Chicago Midway International Airport",
      distance: "Approximately 25 minutes southeast of Elmhurst via I-55",
      address: "5700 S Cicero Ave, Chicago, IL 60638",
      note: "Secondary Chicago airport with strong domestic connections and some international routes. About 25 minutes from Elmhurst via I-55/I-294. Good for Southwest Airlines travelers.",
      flightUrl: "https://www.flychicago.com/midway/",
      flightLabel: "MDW Flight Info",
      featured: false,
    },
  ],
};